import { render } from "./NavbarLink.vue?vue&type=template&id=506d8540&scoped=true"
import script from "./NavbarLink.vue?vue&type=script&lang=js"
export * from "./NavbarLink.vue?vue&type=script&lang=js"

import "./NavbarLink.vue?vue&type=style&index=0&id=506d8540&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506d8540"]])

export default __exports__